import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { Button } from "@mui/material";
import type { ISingleInvoiceVisitor } from "../type/visitorType";
import CreateVisitorMoneyReceipt from "../MoneyReceipt/CreateVisitorMoneyReceipt";

const InvoiceWithMoneyReceiptVis = ({
	invoiceDetails,
}: {
	invoiceDetails?: ISingleInvoiceVisitor;
}) => {
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	return (
		<>
			<Button onClick={() => handleOpen()}>Create MoneyReceipt</Button>
			<ModalsWrapper
				showModal={open}
				setShowModal={setOpen}
				modalData={{ title: "Create Money Receipt" }}
			>
				<CreateVisitorMoneyReceipt
					invoiceDetails={invoiceDetails}
					handleClose={handleClose}
				/>
			</ModalsWrapper>
		</>
	);
};

export default InvoiceWithMoneyReceiptVis;
